// src/config/index.js

const env = process.env.VUE_APP_ENV || process.env.NODE_ENV || 'development';

const config = {
  development: {
    qiniu: 'https://up-z2.qiniup.com',
    qiniu_url: 'https://wap.yukevip.club/',
    rootUrl: '',  // 开发环境使用空值，通过 vue 代理访问
    wx_redirect_uri: 'http://localhost:60002/h5/test/admin/#/callback',  // 开发环境微信回调
  },
  test: {
    qiniu: 'https://up-z2.qiniup.com',
    qiniu_url: 'https://wap.yukevip.club/',
    rootUrl: '/tttt', // 测试环境API
    wx_redirect_uri: 'https://b.app.yukevip.club/h5/test/admin/#/callback',
  },
  production: {
    qiniu: 'https://up-z2.qiniup.com',
    qiniu_url: 'https://wap.yukevip.club/',
    rootUrl: 'https://b.app.yukevip.club', // 正式环境API
    wx_redirect_uri: 'https://b.app.yukevip.club/#/callback', // 正式回调地址（管理后台根目录）
  }
};

export default config[env] || config.development;
export const qiniuUploadUrlNew = 'https://up.qiniup.com'
export const qiniuResourceBaseUrlNew = 'https://wap.yukevip.club/'